import React from 'react';
import proptypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';

const { bool, number, string } = proptypes;

export const GroupProject = ({ itemCount, groupName, disabled }) => {
  return (
    <div>
      <Typography color={!disabled ? 'primary' : 'inactive'}>
        {groupName + ' '}
        <Typography color={!disabled ? 'subtle' : 'inactive'} component="span">
          ({itemCount} Items)
        </Typography>
      </Typography>
    </div>
  );
};

GroupProject.propTypes = {
  itemCount: number.isRequired,
  groupName: string.isRequired,
  disabled: bool
};

GroupProject.defaultProps = {
  disabled: false
};
